import type {
  RangeFilterState,
  SearchFilterState,
  ValueFilterState,
  ZipCodeFilterState,
} from './FilterStore'

/** One layer (applied or pending) of a filter store's filter state. */
export interface FilterStateLayer {
  valueFilters: ValueFilterState
  rangeFilters: RangeFilterState
  search: SearchFilterState
  zipCodeFilter: ZipCodeFilterState
}

/**
 * Count the active filters in a filter-state layer. Value/range/search filters
 * each count once per key; the zip filter counts as one when any zip is set.
 * Centralizes the "how many filters are set" logic that filter badges, the
 * FilterModal Apply gate, and the mobile save-filter affordance all rely on, so
 * "are any filters active" stays correct as new filter types are added.
 *
 * @param layer - The applied or pending filter layer to measure.
 * @returns The number of active filters in that layer.
 */
export function countActiveFilters(layer: FilterStateLayer): number {
  return (
    Object.keys(layer.valueFilters).length +
    Object.keys(layer.rangeFilters).length +
    Object.keys(layer.search).length +
    (layer.zipCodeFilter[0].length > 0 ? 1 : 0)
  )
}
